import {
  RadioGroup as MuiRadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import type { KeyboardEvent } from 'react';

export interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
}

export function RadioGroup({
  options,
  value,
  onChange,
  onBlur,
  disabled = false,
}: RadioGroupProps) {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (disabled) return;

    const currentIndex = options.findIndex((option) => option.value === value);
    const target = event.target as HTMLInputElement;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % options.length : 0;
      onChange(options[nextIndex].value);
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      const nextIndex =
        currentIndex >= 0
          ? (currentIndex - 1 + options.length) % options.length
          : options.length - 1;
      onChange(options[nextIndex].value);
      return;
    }

    if ((event.key === ' ' || event.key === 'Spacebar') && target.value) {
      event.preventDefault();
      onChange(target.value);
    }
  };

  return (
    <MuiRadioGroup
      row
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      sx={{
        gap: 2,
      }}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={
            <Radio
              disabled={disabled}
              sx={{
                color: 'text.secondary',
                '&.Mui-checked': {
                  color: '#00A651',
                },
              }}
            />
          }
          label={option.label}
        />
      ))}
    </MuiRadioGroup>
  );
}
